import Vue from 'vue';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

const options = {
  defaultCountry: 'DE',
  dropdownOptions: {
    showDialCodeInSelection: true
  },
  inputOptions: {
    autofocus: true,
    placeholder: '(000) 000-00-00',
    required: true
  },
  mode: 'international',
  validCharactersOnly: true,
  styleClasses: 'custom-phone-input'
};

Vue.use(VueTelInput, options);
